import { TemplateElement, html, defineElement } from '@webtides/element-js';
import style from './tag.css';

/**
 * @property {'pill' | 'card'} variant
 * @property {string} name
 * @property {boolean} readOnly
 * @property {boolean} selected
 */
export default class Tag extends TemplateElement {
    constructor() {
        super({ styles: [style], shadowRender: true });
    }

    properties() {
        return {
            variant: 'pill',
            name: '',
            readOnly: false,
            selected: false,
        };
    }

    watch() {
        return {
            selected: (selected) => {
                this.$refs.input.checked = selected;
            },
        };
    }

    events() {
        return {
            input: {
                click: (event) => {
                    if (this.readOnly) {
                        event.preventDefault();
                    }
                },
                change: (event) => {
                    this.dispatch('mb-change', event.target.checked);
                },
            },
        };
    }

    template() {
        return html`
            <label variant="${this.variant}">
                <input
                    ref="input"
                    type="checkbox"
                    name="${this.name}"
                    value="${this.name}"
                    ?checked="${this.selected}"
                />
                <slot></slot>
            </label>
        `;
    }
}

defineElement('mb-tag', Tag);
